var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNCircleIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon n-circle-icon",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 1.5a8.5 8.5 0 10.001 17.001A8.5 8.5 0 0010 1.5zM6 14.736h2.15l.728-3.334c.364-1.645 1.264-4.674 2.34-4.674.22 0 .394.122.394.528 0 .163-.031.366-.094.63l-.87 3.863c-.158.71-.284 1.402-.284 1.809 0 .934.38 1.442.932 1.442 1.281 0 2.024-1.585 2.704-2.744l-.332-.305c-.159.305-.68 1.321-1.012 1.321-.11 0-.158-.08-.158-.304 0-.143.031-.366.08-.61l.995-4.35c.063-.244.174-.894.174-1.22 0-.995-.506-1.788-1.312-1.788-1.17 0-2.482 1.423-3.368 3.8l-.031-.04.853-3.537L9.731 5c-.79.427-2.213.569-3.035.569l-.08.55c.665 0 .918.04.918.487 0 .223-.048.732-.127 1.097L6 14.736"
  })));
}

export default SvgNCircleIconSv;